export enum ButtonLabelVisibility {
    Default = "default",
    S = "s",
    M = "m",
    L = "l",
    XL = "xl"
}

export enum ButtonSize {
    Default = "default",
    Icon = "icon",
    IconStretched = "icon-stretched"
}

export enum ButtonVariant {
    Default = "default",
    Primary = "primary",
    NoBorder = "no-border"
}
